__turbopack_context__.v({
  "className": "blFOQa_className",
  "variable": "blFOQa_variable",
});
